<template>
  <div>
    <h1>Copy Miro Board</h1>
    <input v-model="boardUrl" placeholder="Enter the Miro board URL" />
    <button @click="copyBoard">Copy Board</button>
    <div v-if="copyResponse">
      <h2>Copy Response</h2>
      <pre>{{ copyResponse }}</pre>
    </div>
    <div v-if="boardUrl">
      <h2>Change Board Access</h2>
      <button @click="changeAccess('view')">Set to View</button>
      <button @click="changeAccess('edit')">Set to Edit</button>
      <button @click="changeAccess('hidden')">Set to Hidden</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CopyMiroBoardPage',
  data() {
    return {
      boardUrl: "",
      copyResponse: null,
    };
  },
  methods: {
    async copyBoard() {
      try {
        const accessToken = localStorage.getItem('access_token');
        console.log(`URL to send: ${this.boardUrl}`);
        //const response = await fetch("http://127.0.0.1:8000/copy-board", {
        const response = await fetch(`${process.env.VUE_APP_API_URL}/copy-board`, {

          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${accessToken}`
          },
          body: JSON.stringify({ board_url: this.boardUrl }), // Send full URL
        });
        if (!response.ok) {
          throw new Error(`Error: ${response.statusText}`);
        }
        const data = await response.json();
        this.copyResponse = data;
      } catch (error) {
        console.error("Failed to copy board:", error);
      }
    },
    async changeAccess(access) {
      try {
        const accessToken = localStorage.getItem('access_token');
        console.log(`URL to send for access change: ${this.boardUrl}`);
        // const response = await fetch("http://127.0.0.1:8000/change-access", {
        const response = await fetch(`${process.env.VUE_APP_API_URL}/change-access`, {

          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${accessToken}`
          },
          body: JSON.stringify({ board_url: this.boardUrl, access: access }), // Send full URL
        });
        if (!response.ok) {
          throw new Error(`Error: ${response.statusText}`);
        }
        const data = await response.json();
        console.log(`Board access changed to: ${access}`);
      } catch (error) {
        console.error(`Failed to change board access to ${access}:`, error);
      }
    }
  },
};
</script>

<style scoped>
h1 {
  color: #42b983;
}
</style>
